module.exports = __webpack_public_path__ + "img/shield.f14458cc.svg";